/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Plugins_Contact_Support_TextInputs */



/**
* | output |
* | --- |
* | "Teams can purchase additional licenses by contacting" |
*
* @param {Team_Manager_Plugins_Contact_Support_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_plugins_contact_support_text = /** @type {((inputs?: Team_Manager_Plugins_Contact_Support_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Plugins_Contact_Support_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les équipes peuvent acheter des licences supplémentaires en contactant ")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teams können zusätzliche Lizenzen erwerben, indem sie sich an [Kontaktinformationen einfügen] wenden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I team possono acquistare licenze aggiuntive contattando")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Команды могут приобрести дополнительные лицензии, связавшись с нами.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los equipos pueden comprar licencias adicionales contactándose")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("团队可以通过联系以下机构购买额外的许可证：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームは連絡することで追加のライセンスを購入することができます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीमें संपर्क करके अतिरिक्त लाइसेंस खरीद सकती हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As equipes podem adquirir licenças adicionais entrando em contato com")
	return /** @type {LocalizedString} */ ("Teams can purchase additional licenses by contacting ")
});